import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Spin, DatePicker } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import "./Inventory.css";
import { useLocation, useHistory } from "react-router-dom";
import dayjs from "dayjs";

export default function PurchaseProduct() {
  const { Option } = Select;
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [purchaseOrderList, setPurchaseOrderList] = useState([]);
  const location = useLocation();
  const { pr_id } = location.state || {};
  const [selectedReceiveDate, setSelectedReceiveDate] = useState(null);
  const [othersCostType, setOthersCostType] = useState();
  const history = useHistory();

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCenterList(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/supplier_list`, {
        headers: authHeader(),
      })
      .then((response) => {
        setSupplierList(response?.data || []);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/purchase_product_list`, {
        headers: authHeader(),
      })
      .then((response) => {
        setProductList(response?.data || []);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    if (pr_id) {
      axios
        .get(`${config.baseUrl}/inventory/purchase_product/${pr_id}`, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response?.data) {
            const stockProducts = response?.data?.stock_products || [];
            const poItems = response?.data?.po_items || [];

            form.setFieldsValue({
              receive_date: response?.data?.receive_date
                ? dayjs(response?.data?.receive_date)
                : null,
              center_id: response?.data?.center?.center?.employee_id || null,
              po: response?.data?.po || null,
              supplier: response?.data?.supplier?.supplier_id || null,
              challan: response?.data?.challan || null,
              remarks: response?.data?.remarks || null,

              products: stockProducts.map((item) => {
                const matchedPoItem = poItems.find(
                  (po) => po.product.product_id === item?.product?.product_id,
                );
                console.log("matchedPoItem", matchedPoItem);

                return {
                  product_id: item?.product?.product_id || null,
                  discount: Number(item?.discount || 0),
                  po_quantity: Number(matchedPoItem?.quantity || 0),
                  quantity: Number(item?.stock_in || 0),
                  expiry_date: item?.expire_date
                    ? dayjs(item?.expire_date)
                    : null,
                };
              }),
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error,
            confirmButtonText: "Ok",
            icon: "error",
          });
        });
    }
    if (pr_id) {
      axios
        .get(`${config.baseUrl}/inventory/get_pr_cost_type/`, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response?.data) {
            console.log("response?.data", response?.data);
            setOthersCostType(
              Array.isArray(response?.data) ? response?.data || [] : [],
            );
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error,
            confirmButtonText: "Ok",
            icon: "error",
          });
        });
    }
  }, [form, pr_id]);

  const handleCenter = async (value) => {
    setSelectedCenter(value);
    try {
      const response = await axios.get(
        `${config.baseUrl}/inventory/po_list/?pagination=false`,
        {
          headers: authHeader(),
          params: {
            center_id: value,
          },
        },
      );
      setPurchaseOrderList(Array.isArray(response?.data) ? response?.data : []);
    } catch {}
  };

  const handlePoItems = (value) => {
    try {
      const po = purchaseOrderList.find((item) => item?.po_id === value);
      form.setFieldsValue({
        products: [
          ...po?.item_details?.map((item) => ({
            product_id: item?.product?.product_id ?? null,
            discount: Number(item?.discount || 0),
            po_quantity: Number(item?.quantity || 0),
            expiry_date: selectedReceiveDate.add(10, "day"),
          })),
        ],
        supplier: po?.supplier || null,
      });
    } catch (error) {
      console.error("handlePoItems error:", error);
    }
  };

  const handlePriceChange = (value, index) => {
    const newValues = { ...form.getFieldsValue() };
    const rate = value === "" ? 0 : parseFloat(value);
    const discount = parseFloat(newValues.products[index].discount) || 0;
    const quantity = parseFloat(newValues.products[index].quantity) || 0;
    const calculatedTotalPrice = rate * quantity - discount;

    newValues.products[index].product_total_price =
      calculatedTotalPrice?.toFixed(2);

    form.setFieldsValue({ ...newValues });
    calculateTotalPrice();
  };

  const handleQuantityChange = (value, index) => {
    const newValues = { ...form.getFieldsValue() };
    const rate = parseFloat(newValues.products[index].purchase_price) || 0;
    const discount = parseFloat(newValues.products[index].discount) || 0;
    const quantity = value === "" ? 0 : parseInt(value);
    const calculatedTotalPrice = rate * quantity - discount;

    newValues.products[index].product_total_price =
      calculatedTotalPrice?.toFixed(2);

    form.setFieldsValue({ ...newValues });
    calculateTotalPrice();
  };

  const handleDiscountAdd = (value, index) => {
    const newValues = form.getFieldsValue();
    const quantity = newValues.products[index].quantity;
    const rateKey = newValues.products[index].purchase_price;

    const calculatedTotalPrice = rateKey * quantity;

    if (value) {
      const discountedTotalPrice = Math.max(calculatedTotalPrice - value, 0);
      newValues.products[index].product_total_price =
        discountedTotalPrice?.toFixed(2);
    } else {
      newValues.products[index].product_total_price =
        calculatedTotalPrice?.toFixed(2);
    }

    form.setFieldsValue(newValues);
    calculateTotalPrice();
  };

  const calculateTotalPrice = () => {
    const formValues = form.getFieldsValue();
    const products = formValues.products || [];
    const othersCost = formValues.others_costs || [];
    const newTotalPriceSum = products.reduce((sum, product) => {
      return sum + (parseFloat(product?.product_total_price) || 0);
    }, 0);
    const othersCostSum = othersCost.reduce((sum, cost) => {
      return sum + (parseFloat(cost?.cost_amount) || 0);
    }, 0);

    form.setFieldValue(
      "total_price",
      Number(newTotalPriceSum + othersCostSum).toFixed(2),
    );
  };

  const handleSubmit = (data) => {
    setLoading(true);
    const payload = {
      ...data,
      receive_date: data.receive_date
        ? data.receive_date.format("YYYY-MM-DD")
        : null,
    };
    // Check if pr_id exists in the data
    const url = pr_id
      ? `${config.baseUrl}/inventory/purchase_update/${pr_id}/` // Update URL
      : `${config.baseUrl}/inventory/purchase_create/${selectedCenter}/`; // Create URL

    const method = pr_id ? "put" : "post"; // 'put' for update, 'post' for create

    axios({
      method: method,
      url: url,
      data: { data: payload },
      headers: authHeader(),
    })
      .then((result) => {
        setLoading(false);
        if (result?.status === 200 || result?.status === 201) {
          const message = result?.data?.message || "Operation successful!";
          Swal.fire({
            title: "Success",
            text: message,
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            form.resetFields();
            form.setFieldsValue({
              products: [],
            });
            history.push("/managePurchase");
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message || "Something went wrong.",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  return (
    <div className="farmerDashboard">
      <div className="dashboardNameSection">
        <h5 style={{ color: "#46604A" }}>PRODUCT RECEIVE</h5>
      </div>
      <div className="farmerDashboardContainer shadow-sm rounded">
        <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
          <div
            className="shadow-sm p-3"
            style={{ border: "1px solid #46604A" }}
          >
            <Form
              form={form}
              color="#46604A"
              onFinish={handleSubmit}
              layout="vertical"
            >
              <div className="d-flex justify-content-between">
                <Col style={{ width: "150px" }}>
                  <Form.Item
                    hasFeedback
                    name="receive_date"
                    rules={[
                      {
                        required: true,
                        message: "Please insert receive date",
                      },
                    ]}
                  >
                    <DatePicker
                      onChange={(value) => {
                        setSelectedReceiveDate(value);
                        setPurchaseOrderList([]);
                        setSelectedCenter("");
                        form.setFieldValue("po", "");
                        form.setFieldValue("supplier", "");
                        form.setFieldValue("products", []);
                        form.setFieldValue("center_id", "");
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: "200px" }}>
                  <Form.Item
                    hasFeedback
                    name="center_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select center",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Center"
                      onChange={handleCenter}
                      disabled={!selectedReceiveDate}
                    >
                      {centerList?.map((center) => (
                        <Option
                          value={center?.center?.employee_id}
                          key={center?.center?.employee_id}
                        >
                          {center?.center_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ width: "350px" }}>
                  <Form.Item
                    hasFeedback
                    name="po"
                    rules={[
                      {
                        required: true,
                        message: "Please select PO",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Purchase Order"
                      disabled={!selectedReceiveDate}
                      options={purchaseOrderList?.map((po) => ({
                        value: po?.po_id,
                        label: `${po?.po_id} / ${po?.supplier_name} / ${po?.po_date}`,
                      }))}
                      onChange={(value) => {
                        handlePoItems(value);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col style={{ width: "250px" }}>
                  <Form.Item
                    hasFeedback
                    name="supplier"
                    rules={[
                      {
                        required: true,
                        message: "Please select supplier",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Supplier"
                      showSearch
                      disabled
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {supplierList?.map((supplier) => (
                        <Option
                          value={supplier?.supplier_id}
                          key={supplier?.supplier_id}
                        >
                          {supplier?.supplier_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col style={{ width: "200px" }}>
                  <Form.Item
                    hasFeedback
                    name="challan"
                    rules={[
                      {
                        required: true,
                        message: "Please insert challan",
                      },
                    ]}
                  >
                    <Input placeholder="Challan" />
                  </Form.Item>
                </Col>
              </div>
              <Form.Item hasFeedback name="remarks">
                <Input.TextArea placeholder="Remarks" />
              </Form.Item>

              <Form.List name="products">
                {(fields, { add, remove }) => (
                  <div
                    className="p-3 mb-5"
                    style={{ color: "#46604A", border: "1px solid #46604A" }}
                  >
                    <Row>
                      <Col lg={4}>
                        <Form.Item>
                          <Button
                            type="default"
                            onClick={() =>
                              add({
                                discount: 0,
                                quantity: 1,
                              })
                            }
                            block
                            size="small"
                            icon={<PlusOutlined />}
                            style={{ color: "#000000" }}
                          >
                            Add product
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>

                    {fields.map(({ key, name, ...restField }, index) => (
                      <Row
                        key={key}
                        gutter={[16, 16]} // ✅ FIXED: only 2 values allowed
                        align="middle"
                      >
                        <Col span={3}>
                          <Form.Item
                            {...restField}
                            label="Product Name"
                            name={[name, "product_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Product is required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select product name"
                              showSearch
                              optionFilterProp="label"
                            >
                              {productList?.map((product) => (
                                <Select.Option
                                  key={product.product_id}
                                  value={product.product_id}
                                  label={product.product_name}
                                >
                                  {product.product_name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        {pr_id && (
                          <Col span={3}>
                            {" "}
                            {/* Fixed column width for price */}
                            <Form.Item
                              {...restField}
                              label="Price"
                              name={[name, "purchase_price"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter product price",
                                },
                                {
                                  pattern: /^[0-9]+(\.[0-9]+)?$/,
                                  message: "Only numbers allowed",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Price"
                                onChange={(e) =>
                                  handlePriceChange(
                                    Number(e.target.value),
                                    index,
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        )}

                        <Col span={3}>
                          {" "}
                          {/* Fixed column width for PO quantity */}
                          <Form.Item
                            {...restField}
                            label="PO Quantity"
                            name={[name, "po_quantity"]}
                          >
                            <Input disabled placeholder="PO Quantity" />
                          </Form.Item>
                        </Col>

                        <Col span={3}>
                          {" "}
                          {/* Fixed column width for receiving quantity */}
                          <Form.Item
                            {...restField}
                            label="Receiving Quantity"
                            name={[name, "quantity"]}
                            rules={[
                              {
                                required: true,
                                message: "Purchase quantity required",
                              },
                              {
                                pattern: /^[0-9]+$/,
                                message: "Only numbers allowed",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Quantity"
                              onChange={(e) =>
                                handleQuantityChange(
                                  Number(e.target.value),
                                  index,
                                )
                              }
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          {" "}
                          {/* Fixed column width for expiry date */}
                          <Form.Item
                            {...restField}
                            label="Expiry Date"
                            name={[name, "expiry_date"]}
                            rules={[
                              {
                                required: true,
                                message: "Please insert expiry date",
                              },
                            ]}
                          >
                            <DatePicker
                              format="YYYY-MM-DD"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>

                        {pr_id && (
                          <Col span={3}>
                            {" "}
                            {/* Fixed column width for discount */}
                            <Form.Item
                              {...restField}
                              label="Discount"
                              name={[name, "discount"]}
                              initialValue={0}
                              rules={[
                                {
                                  pattern: /^[0-9]+(\.[0-9]+)?$/,
                                  message: "Only numbers allowed",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Discount"
                                onChange={(e) =>
                                  handleDiscountAdd(
                                    Number(e.target.value || 0),
                                    index,
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        )}

                        {pr_id && (
                          <Col span={4}>
                            <Form.Item
                              {...restField}
                              label="Product Total Price"
                              name={[name, "product_total_price"]}
                              rules={[{ required: true }]}
                            >
                              <Input readOnly />
                            </Form.Item>
                          </Col>
                        )}

                        {fields.length > 1 && (
                          <Col span={1}>
                            <Button
                              danger
                              onClick={() => {
                                remove(name);
                                calculateTotalPrice();
                              }}
                              className="d-flex justify-content-center align-items-center"
                            >
                              <MinusCircleOutlined />
                            </Button>
                          </Col>
                        )}
                      </Row>
                    ))}
                  </div>
                )}
              </Form.List>

              {pr_id && (
                <>
                  <div className="d-flex justify-content-around">
                    <p
                      className="text-center"
                      style={{ color: "#46604A", fontSize: 16 }}
                    >
                      <strong>Others Cost</strong>
                    </p>
                    <p
                      className="text-center"
                      style={{ color: "#46604A", fontSize: 16 }}
                    >
                      <strong>Payment Method </strong>
                    </p>
                  </div>
                  <div className="d-flex shadow-sm mb-4">
                    <div
                      className="w-50 pt-4 d-flex flex-column align-items-center"
                      style={{ color: "#46604A", border: "1px solid #46604A" }}
                    >
                      <Form.List name="others_costs">
                        {(fields, { add, remove }) => (
                          <>
                            <div className="w-100 d-flex justify-content-between mb-2">
                              <Button
                                className="w-25 ms-2"
                                onClick={() => add()}
                                block
                                size="small"
                                icon={<PlusOutlined />}
                                style={{ color: "#000000" }}
                              >
                                Add others cost
                              </Button>
                            </div>

                            {/* Dynamic Rows (CENTERED) */}
                            {fields.map(
                              ({
                                key,
                                index,
                                fieldKey,
                                name,
                                ...restField
                              }) => (
                                <div
                                  key={key}
                                  className="d-flex justify-content-between align-items-center mb-2"
                                  style={{
                                    // border: "1px solid #46604A",
                                    width: "90%",
                                    padding: "8px", // Adding some padding for better spacing inside the div
                                  }}
                                >
                                  {/* Cost Type */}
                                  <Col span={10}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cost_type"]}
                                      fieldKey={[fieldKey, "cost_type"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Cost type required",
                                        },
                                      ]}
                                      className="flex-fill me-2"
                                      style={{ marginBottom: 0 }}
                                    >
                                      <Select placeholder="Cost Type">
                                        {othersCostType?.map((item) => (
                                          <Select.Option
                                            key={item?.id}
                                            value={item?.id}
                                          >
                                            {item?.cost_type}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  {/* Cost Amount */}
                                  <Col span={10}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cost_amount"]}
                                      fieldKey={[fieldKey, "cost_amount"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Cost amount required",
                                        },
                                        {
                                          pattern: /^[0-9]+$/,
                                          message: "Only English numbers",
                                        },
                                      ]}
                                      className="flex-fill me-2"
                                      style={{ marginBottom: 0 }}
                                    >
                                      <Input
                                        placeholder="Cost Amount"
                                        className="text-center"
                                        disabled={restField?.[index]?.cost_type}
                                        onChange={() => {
                                          calculateTotalPrice();
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  {/* Remove */}
                                  <Col span={4}>
                                    <MinusCircleOutlined
                                      onClick={() => {
                                        remove(name);
                                        calculateTotalPrice();
                                      }}
                                      style={{
                                        color: "red",
                                        fontSize: 16,
                                        cursor: "pointer", // Change cursor to pointer for better UX
                                      }}
                                    />
                                  </Col>
                                </div>
                              ),
                            )}
                          </>
                        )}
                      </Form.List>
                    </div>

                    {/* RIGHT SIDE (TOTAL) — unchanged */}
                    <div
                      className="w-50 pt-4"
                      style={{ color: "#46604A", border: "1px solid #46604A" }}
                    >
                      <div className="d-flex justify-content-center">
                        <Form.Item className="ms-2">
                          <Input
                            className="py-2 text-center custom-placeholder-color"
                            placeholder="Total"
                            disabled
                            style={{ color: "#46604A", borderColor: "#46604A" }}
                          />
                        </Form.Item>

                        <Form.Item
                          className="ms-2"
                          name="total_price"
                          rules={[
                            { required: true, message: "Total price missing" },
                          ]}
                        >
                          <Input
                            className="py-2 text-center"
                            placeholder="Total Price"
                            readOnly
                            style={{ color: "#46604A", borderColor: "#46604A" }}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="d-flex justify-content-end ">
                {pr_id && (
                  <Form.Item className="me-2" name="status">
                    <Select
                      placeholder="Select Status"
                      rules={[{ required: true, message: "Status required" }]}
                      className="flex-fill me-2"
                      style={{ marginBottom: 0, width: "200px" }}
                    >
                      <Option value="Draft">Draft</Option>
                      <Option value="Complete">Complete</Option>
                    </Select>
                  </Form.Item>
                )}
                <Form.Item className="d-flex justify-content-end ">
                  <Button
                    htmlType="submit"
                    a
                    disabled={loading}
                    style={{ color: "#ffffff", backgroundColor: "#46604A" }}
                  >
                    Submit
                    {loading && <Spin size="small" style={{ marginLeft: 8 }} />}
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
